module.exports = __webpack_public_path__ + "img/cash.54b76ff6.svg";